import { GRAY_700, GRAY_900 } from 'constants/styling/theme'

import React from 'react'
import Stack from '@mui/material/Stack'
import { SxProps } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useClientGallery } from 'components/pages/Gallery/_main/ClientGallery/_main'
import { useTranslation } from 'react-i18next'

/** @interface Props for the ClientAssignmentReference component. */
interface Props {
  /** Optional CSS props to apply to the component. */
  sx?: SxProps
}

/**
 * @component
 * `ClientAssignmentReference` displays assignment reference label and its corresponding assignment ID.
 *
 * @example
 * <ClientAssignmentReference />
 */
export const ClientAssignmentReference: React.FC<Props> = ({ sx }) => {

  const { t } = useTranslation(['gallery'])
  const { assignmentId } = useClientGallery()

  return (
    <Stack
      gap={0.6}
      marginRight="auto" // Because it's usually placed on the left
      flexDirection="row"
      sx={sx}
    >

      <Typography variant="text-sm" fontWeight={600} color={GRAY_900}>
        {`${t('assignment_reference')}:`}
      </Typography>

      <Typography variant="text-sm" fontWeight={600} color={GRAY_700}>
        {assignmentId}
      </Typography>

    </Stack>
  )
}
